<template>
    <div>
        <a :href="product.url">
            <img :src="product.images['255x255'][0]">

            <p>{{ product.name }}</p>
            <div v-html="displayPrice()"></div>
        </a>
    </div>
</template>

<script>
    export default {
        props: ['product', 'active'],
        methods: {
            displayPrice() {
                const price = this.product.pricing[0];

                if (price.sale_amount > 0) {
                    return `<h5 class="oldprice">${ price.formatted }</h5><h5 class="newprice">${price.sale_formatted}</h5>`;
                }

                return `<h5>${ price.formatted }</h5>`;
            },
        },
    }
</script>